export const GET_HDM_REPORT = "get_hdm_report";